import { motion } from "framer-motion";
import { HeartHandshake, Sparkles, Users, LineChart } from "lucide-react";

const items = [
  {
    icon: HeartHandshake,
    title: "Warm, judgement-free space",
    body: "A calm clinic where children feel safe and parents feel heard from the very first visit.",
  },
  {
    icon: Sparkles,
    title: "Evidence-based methods",
    body: "Every session is grounded in proven ABA principles and tailored to your child's goals.",
  },
  {
    icon: Users,
    title: "Parents in the loop",
    body: "Regular coaching and updates so you can support progress confidently at home.",
  },
  {
    icon: LineChart,
    title: "Measurable progress",
    body: "Clear data and honest reports show exactly how your child is growing over time.",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 30 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Outcomes = () => {
  return (
    <section id="outcomes" className="py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.4 }}
          className="max-w-2xl mb-16"
        >
          <p className="text-sm tracking-[0.2em] uppercase text-brand-secondary mb-5">Why families choose us</p>
          <h2 className="font-display font-light text-4xl sm:text-5xl tracking-tight text-brand-primary">
            Care that treats the whole family.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={it.title}
                custom={i}
                variants={reveal}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.3 }}
                data-testid={`outcome-card-${i}`}
                className="rounded-3xl bg-brand-accent/40 p-8 hover:-translate-y-1 hover:bg-brand-accent/60 transition-all duration-300"
              >
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-brand-primary text-brand-bg mb-6">
                  <Icon strokeWidth={1.5} className="h-5 w-5" />
                </span>
                <h3 className="font-display text-xl text-brand-primary mb-3">{it.title}</h3>
                <p className="text-brand-ink/70 leading-relaxed text-[15px]">{it.body}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
